import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c9506ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-swiper container-custom" }
const _hoisted_2 = { class: "banner-swiper__wrap" }
const _hoisted_3 = { class: "banner-swiper__item-content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "banner-swiper__item-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CarouselCardItem = _resolveComponent("CarouselCardItem")!
  const _component_CarouselCard = _resolveComponent("CarouselCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_component_CarouselCard, {
        class: "banner-swiper__container",
        ref: "carouselCardRef",
        interval: 7000,
        autoplay: true,
        type: "card",
        arrow: "always",
        onChange: _ctx.changeHandle,
        key: _ctx.listProducts
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listProducts, (item, index) => {
            return (_openBlock(), _createBlock(_component_CarouselCardItem, {
              class: "banner-swiper__item",
              key: index,
              onClick: ($event: any) => (_ctx.$emit('clickItem', item))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _ctx.getBeerImage(item.country_slug)
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.country_name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onChange"]))
    ])
  ]))
}